<mat-card appearance="outlined">
  <mat-list>
    @for (category of taskCategories; track trackByCategory($index, category)) {
      <mat-list-item
        >
        <div
          class="category-item"
          fxLayout="row"
          fxLayoutAlign="space-between center"
          >
          <div class="category-item__categoryName" fxFlex="45%">
            <span class="category-item-part"
              >Part {{ getCategoryOrder(category) }}:</span
              >
              {{ category.displayName }}
            </div>
            <div fxFlex="50%">
              <button
                fxShow
                fxHide.lt-sm
                mat-button
                color="primary"
                (click)="openCategoryDialog(category)"
                >
                Preview Activities
              </button>
              <!-- Preview button for x-small screens -->
              <button
                fxHide
                fxShow.xs
                mat-button
                color="primary"
                (click)="openCategoryDialog(category)"
                >
                Preview
              </button>
            </div>
            <div>
              @if (!creatingLesson) {
                <mat-checkbox
                  disableRipple="true"
                  (click)="$event.stopPropagation()"
                  [checked]="isCategorySelected(category)"
                  (change)="toggleCategory($event, category)"
                  >
                </mat-checkbox>
              }
            </div>
          </div>
          @if (taskCategories.length > 1) {
            <mat-divider></mat-divider>
          }
        </mat-list-item>
      }
    </mat-list>
  </mat-card>
